import React from 'react';
import { Link } from 'react-router-dom';

class Field extends React.Component {

    componentDidMount() {
        document.querySelector("main").scrollIntoView();
    }

    render() {
        return (
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col col-lg-10 g-pb-10">
                        <ul className="nav nav-justified u-nav-v2-1 u-nav-primary g-mt-20 g-mb-40">
                            <li className="nav-item"><Link to="#!" className="nav-link g-brd-gray-light-v4 g-font-size-16 active">교실 속 동물들</Link></li>
                            <li className="nav-item"><Link to="/home/field2" className="nav-link g-brd-gray-light-v4 g-font-size-16">학교동물 보호방법</Link></li>
                        </ul>

                        <div className="row g-py-10">
                            <div className="col-md-3">
                                <h3 className="h4 g-font-weight-600">또다른 동물학대</h3>
                            </div>
                            <div className="col-md-9">
                                <p className="g-line-height-2">
                                    학년이 끝나면 교실 속의 거북이, 다람쥐는 어떻게 될까요?<br />
                                    동물에 대해 배우기 위해 실내에서 거북이나 다람쥐를 키우는 경우를 생각해 봅시다. 동물이라는 소주제가 끝날 때, 혹은 학년이 마무리되는 연말에, 이 동물들은 어떻게 될까요?<br />
                                    동물도 좋음, 싫음, 아픔, 무료함을 느끼는 생명인데, 이렇게 실내에 매우 좁은 우리에 가두고 많은 사람에게 노출시키는 것은 아이들로 하여금 거북이나 다람쥐를 나름의 멋진 생명이 아닌 ‘움직이는 인형’으로 여기게 할 수 있습니다. 동물이란 존재는 우리 몇몇의 잠깐의 배움을 위해 그들의 생명을 저당잡고, 좁은 곳에 가두어도 되는 대상이라는 배움을 얻어가게 될 수도 있습니다.
					            </p>
                            </div>
                        </div>

                        <div className="row g-py-10">
                            <div className="col-md-3">
                                <h3 className="h4 g-font-weight-600">학교동물의 복지</h3>
                            </div>
                            <div className="col-md-9">
                                <p className="g-line-height-2">
                                    동물은 자신의 자연스러운 서식지에 있을 때 제 모습대로 살아갑니다.
                                    동물을 관찰하는 기쁨은 서식지에 찾아가는 노력을 기울이고, 동물을 방해하지 않기 위해 거리를 유지하는 절제를 발휘할 때에만 자격이 주어지는 것입니다.
                                    반려동물의 경우는 그 반려인이 동물의 생로병사를 아우르는 생애 전 과정에 걸쳐 책임있게 함께하겠다는 약속이 있기에 가까이 지낼 수 있는 것입니다.
                                </p>
                            </div>
                        </div>

                        <div className="row g-py-10">
                            <div className="col-md-3">
                                <h3 className="h4 g-font-weight-600">우리의 현실</h3>
                            </div>
                            <div className="col-md-9">
                                <p className="g-line-height-2">
                                    이제는 우리의 교육 현장에서 해부수업이 사라지고 있고, 학교에서 이런 저런 동물을 키운다거나, 동물복지가 열악한 이동형 동물원을 초대하는 것을 우려하고,
                                    이를 막으려면 어떻게 해야 하냐는 학부모들의 문의도 동물보호단체에 쏟아집니다.<br />
                                    2016년 5월 16일자 한 기사(어린이 행사후 폐기물과 함께 처리되는 동물들 '충격')에서는 어린이날 기념으로 어린이들에게 곤충을 관찰하거나 작은 동물을 만져보는 등의 체험을 제공하는 행사 이후,
                                    햄스터, 토끼, 기니피그 등의 동물을 유기동물보호소에 보내는 방식으로 폐기해 왔음을 보도했습니다.
                                    이런 행사에 아이들을 참여시키는 것은, 동물학대를 체험하게 하고, 동물학대의 공범자가 되도록 방치하는 행동이 아닐까 하는 생각마저 듭니다.
					            </p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}

export default Field;


// WEBPACK FOOTER //
// ./src/pages/front/home/field.js